import { SetStateAction, useCallback, useState } from 'react'
import { IPGroup, OnnetOffnetRow } from './reducer'

export default function OnnetOffnetHooks() {
  const [ipv4, setIpv4] = useState<Array<OnnetOffnetRow>>([])
  const [ipv6, setIpv6] = useState<Array<OnnetOffnetRow>>([])

  const selectEntry = useCallback((ipGroup: IPGroup, index: number) => {
    if (ipGroup === IPGroup.v4) {
      return setIpv4(current => current.map((entry, entryIndex) => mapEditable(entry, entryIndex, index)))
    }

    return setIpv6(current => current.map((entry, entryIndex) => mapEditable(entry, entryIndex, index)))
  }, [])

  const saveEntry = useCallback((ipGroup: IPGroup, index: number, entry: string) => {
    if (ipGroup === IPGroup.v4) {
      return handleSave(index, entry, ipv4, setIpv4)
    }

    handleSave(index, entry, ipv6, setIpv6)
  }, [])

  const saveNewEntry = useCallback((ipGroup: IPGroup, entry: string) => {
    const newEntry = {
      entry,
      entryStatus: 'ADD',
      editable: false,
      newEntry: true,
    }

    if(ipGroup === IPGroup.v4) {
      return setIpv4(current => ([newEntry, ...current]))
    }

    setIpv6(current => ([newEntry, ...current]))
  }, [])

  const removeEntry = useCallback((ipGroup: IPGroup, index: number) => {
    if (ipGroup === IPGroup.v4) {
      return handleRemove(index, ipv4, setIpv4)
    }

    handleRemove(index, ipv6, setIpv6)
  }, [])

  return {
    ipv4,
    setIpv4,
    ipv6,
    setIpv6,
    selectEntry,
    saveEntry,
    saveNewEntry,
    removeEntry,
  }
}

function handleRemove(index: number, range: Array<OnnetOffnetRow>, setRange: React.Dispatch<SetStateAction<Array<OnnetOffnetRow>>>) {  
  if (range[index]?.newEntry) {
    return setRange(current => current.splice(index, 1))
  }

  setRange((range) => range.map((entry, i) => i === index ? {...entry, entryStatus: 'DELETE' } : entry ))
}

function handleSave(index: number, entry: string, range: Array<OnnetOffnetRow>, setRange: React.Dispatch<SetStateAction<Array<OnnetOffnetRow>>>){
  if(!range[index]?.newEntry) {
    setRange(current => [...current, { entry: current[index].entry, editable: false, entryStatus: 'DELETE' }])
  }

  setRange(current => current.map((ipEntry, entryIndex) => index === entryIndex ? { entry, entryStatus: 'ADD', editable: false } : ipEntry))
}

function mapEditable(entry: OnnetOffnetRow, entryIndex: number, index: number) {
  if (entryIndex === index) {
    return { ...entry, editable: true }
  }

  return entry
}